import React from 'react';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import Offer from './Offer';

interface MultipleOffersProps {
  offers: OfferOption[];
  selectedOffer: SelectedOffer;
  setSelectedOffer: (plan: SelectedOffer) => void;
}

const MultipleOffers = ({ offers, selectedOffer, setSelectedOffer }: MultipleOffersProps) => {
  return (
    <div>
      <div className="tw-mt-24 tw-mb-20 tw-flex tw-items-center">
        <div className="tw-text-primary-red tw-text-body-sm tw-uppercase tw-font-bold tw-font-sans">
          Choose Plan
        </div>
        <div className="tw-ml-12 tw-flex-1 tw-bg-primary-red tw-h-2"></div>
      </div>
      {offers.map((offer, index) => (
        <Offer
          key={index}
          {...offer}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
        />
      ))}
    </div>
  );
};

export default MultipleOffers;
